import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
} from '@/lib/graphql-query-builder';

/**
 * The Blocks OS gateway names query operations `get<Collection>`, not the bare collection name. Each
 * operation is aliased to the collection name so services and hooks keep reading `result.<Collection>`.
 * Confirm exact names with `blocks data schema get <id>`.
 *
 * KpiConfiguration is an append-only history: every save inserts a row (legacy
 * KpiConfigurationService.SaveConfiguration) and the effective configuration is the
 * newest one: newest first, like the old `OrderByDescending(x => x.CreateDate)`, and the service
 * takes the first item.
 */
export const buildGetKpiConfigurationQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    KpiConfigurations: getKpiConfigurations(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral([{ field: 'CreatedDate', direction: 'DESC' }])}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ItemId
        CreatedDate
        QnMatrixMinLevel
        QnMatrixMaxLevel
        NormalizedMaxScale
        ReviewerGroupWeightsJson
        CategoryWeightsJson
      }
    }
  }
`;
